/**
 *  header의 높이
 * @returns {string} 70px
 *  */
export const HEADER_HEIGHT: string = '70px';

/**
 *  footer의 높이
 * @returns {string} 200px
 *  */
export const FOOTER_HEIGHT: string = '156px';

/**
 *  max-width: 580px 일 때의 footer의 높이
 * @returns {string} 180px
 *  */
export const MOBILE_FOOTER_HEIGHT: string = '180px';

/**
 *  자동차 애니메이션 추가적인 footer 높이
 * @returns {string} 50px;
 *  */
export const FOOTER_ROAD_HEIGHT: string = '50px';

/**
 *  PC 웹화면에서 body의 최대 가로 길이
 * @returns {string} 1024px
 */
export const BODY_WIDTH: string = '1024px';

/**
 *  모달의 수평 패딩 수치
 * @return {string} 35px
 *  */
export const MODAL_PADDING_HOR: string = '35px';

/**
 *  모달의 수직 패딩 수치
 * @return {string} 30px
 *  */
export const MODAL_PADDING_VER: string = '35px';

/**
 *  견적서 테이블의 th 가로 길이
 * @returns {string} 66px;
 *  */
export const ESTIMATE_TH_WIDTH: string = '66px';
